import React from 'react';

import { Button, Flex, Text } from '@opendoor/bricks/core';

import { HomeAssessmentData } from '../../graphql/athena/useExteriorAssessment';
import {
  experiencePartnerDataProps,
  lwcProductDataProps,
  offerDataProps,
} from '../../helpers/getAllLeadData';
import { ConvertedToSellDirectForm } from '../../routes/LwcDashboard/ConvertedToSellDirectForm';
import { ExperiencePartnerInfo } from '../../routes/LwcDashboard/ExperiencePartnerInfo';

interface OfferInfoProps {
  offerData?: offerDataProps;
  experiencePartner?: experiencePartnerDataProps;
  lwcProductId: string;
  lwcProductData: lwcProductDataProps;
  homeAssessmentData: HomeAssessmentData;
}

export const OfferInfo: React.FC<OfferInfoProps> = ({
  offerData,
  lwcProductId,
  experiencePartner,
  lwcProductData,
  homeAssessmentData,
}) => {
  const [showOfferInfo, setShowOfferInfo] = React.useState(false);
  const lwcProductState = lwcProductData?.lwcProductState;
  const conversionNote = lwcProductData?.leadPassBackNote;
  const leadPassNote = lwcProductData.cepNote;

  return (
    <Flex
      flexDirection="column"
      fontSize="s2"
      p={3}
      borderRadius="semiRounded"
      backgroundColor="neutrals10"
    >
      <Button
        analyticsName="open-offer-info"
        variant="secondary"
        onClick={() => {
          setShowOfferInfo(!showOfferInfo);
        }}
        aria-label="Open offer information"
      >
        <Text fontWeight="semibold">{`${showOfferInfo ? 'Hide' : 'Show'} Opendoor details`} </Text>
      </Button>
      {showOfferInfo && (
        <>
          <Text fontWeight="semibold">Opendoor details:</Text>
          {offerData?.state == 'WAITING_FOR_LIST_WITH_CERTAINTY' && offerData?.expiresAt && (
            <Text>Final offer expires at: {offerData?.expiresAt}</Text>
          )}
          {offerData?.finalOfferData?.finalOfferViewedAt && (
            <Text>
              Final offer viewed by customer on: {offerData?.finalOfferData?.finalOfferViewedAt}
            </Text>
          )}

          {homeAssessmentData && <Text>Exterior Assessment: {homeAssessmentData.stateString}</Text>}
          <Text>
            Estimated listing range: {<br />}
            {offerData?.listingEstimateFloor} - {offerData?.listingEstimateCeiling}
          </Text>
          <ExperiencePartnerInfo experiencePartner={experiencePartner} />
          {leadPassNote && leadPassNote !== '' && (
            <>
              <Text fontSize={'s2'} fontWeight="semibold">
                Notes about the customer
              </Text>

              <blockquote>
                <Text fontSize={'s1'}>{leadPassNote}</Text>
              </blockquote>
            </>
          )}

          {offerData?.state !== 'SENT' &&
            offerData?.state !== 'EXPIRED' &&
            offerData?.finalOfferData && (
              <>
                <Text fontWeight="semibold">Final offer data:</Text>
                <Text>Opendoor final offer value: {offerData.finalOfferData.finalOfferPrice}</Text>
                <Text>
                  Opendoor fee:{' '}
                  {`${offerData.finalOfferData.finalizedFeeCost} (${offerData.finalOfferData.finalOfferFeePercentage})`}
                </Text>
                <Text>
                  Estimated closing costs: {offerData.finalOfferData.estimatedClosingCosts}
                </Text>
                <Text>Repair costs: {offerData.finalOfferData.repairCosts}</Text>
                <Text>Estimated net proceeds: {offerData.finalOfferData.estimatedNetProceeds}</Text>
              </>
            )}
          <ConvertedToSellDirectForm
            lwcProductId={lwcProductId}
            lwcProductState={lwcProductState}
            conversionNote={conversionNote ?? ''}
          />
        </>
      )}
    </Flex>
  );
};
